<template>
<div class="image-viewer card shadow p-3">
    <template v-if="lightboxActiveIndex !== -1">
      <div class="overlay"></div>
      <div class="lightbox" @click="lightboxActiveIndex = -1">
        <img :src="value[lightboxActiveIndex]" />
      </div>
    </template>
    <div class="container p-0">
      <img @click="lightboxActiveIndex = i" v-for="(path, i) in value" class="icon-48 mr-1" :src="path" :key="i" />
    </div>
</div>
</template>

<script>
export default {
  data: () => ({
    lightboxActiveIndex: -1,
  }),
  props: {
    value: {
        type: Array,
        default: () => ([])
    }
  }
}
</script>

<style lang="scss">
.image-viewer {
  .overlay {
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0;
    background: rgba(#000000, 0.75);
    z-index: 9;
  }
  .lightbox {
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    img {
      width: calc(100% - 24px);
      height: auto;
    }
  }
}
</style>
